(function(){
'use strict';
var T=window.theme||{routes:{},strings:{}};
var $=function(s,c){return(c||document).querySelector(s)};
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
window.dataLayer=window.dataLayer||[];

/* ---------- analityka (GA4 / GTM / Meta Pixel) ---------- */
function track(ev,params){
  try{
    var e=(params&&params.ecommerce)||null;
    if(typeof window.gtag==='function'){window.gtag('event',ev,e||params||{});}
    else{window.dataLayer.push({ecommerce:null});var o={event:ev};if(e){o.ecommerce=e}else{for(var k in params){o[k]=params[k]}}window.dataLayer.push(o);}
    if(typeof window.fbq==='function'){
      var m={view_item:'ViewContent',add_to_cart:'AddToCart',begin_checkout:'InitiateCheckout',search:'Search',newsletter_signup:'Lead'};
      if(m[ev]){
        window.fbq('track',m[ev],ev==='search'?{search_string:params.search_term}:{currency:e&&e.currency,value:e&&e.value,content_type:'product',contents:((e&&e.items)||[]).map(function(i){return{id:i.item_id,quantity:i.quantity||1}})});
      }
    }
  }catch(err){}
}
window.lumiTrack=track;
function toItem(i){return{item_id:String(i.product_id||i.id),item_name:i.product_title||i.title,item_variant:i.variant_title||undefined,price:(i.price||0)/100,quantity:i.quantity||1}}

/* ---------- powiadomienie ---------- */
var toastEl=$('[data-toast]'),toastTimer;
function toast(msg,isErr,link){
  if(!toastEl)return;
  toastEl.innerHTML='';toastEl.className='toast'+(isErr?' toast--error':'');
  var s=document.createElement('span');s.textContent=msg;toastEl.appendChild(s);
  if(link){var a=document.createElement('a');a.href=T.routes.cart;a.textContent=T.strings.viewCart;toastEl.appendChild(a)}
  toastEl.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(function(){toastEl.hidden=true},5000);
}
function refreshCount(){
  return fetch(T.routes.cart+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
    $$('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=c.item_count===0});return c;
  });
}

/* ---------- menu mobilne i wyszukiwarka ---------- */
var menuBtn=$('[data-menu-toggle]'),nav=$('#mobile-nav');
function setNav(open){
  nav.hidden=!open;menuBtn.setAttribute('aria-expanded',String(open));document.documentElement.classList.toggle('no-scroll',open);
  if(open){var c=$('[data-menu-close]',nav);c&&c.focus()}else{menuBtn.focus()}
}
if(menuBtn&&nav){
  menuBtn.addEventListener('click',function(){setNav(true)});
  $$('[data-menu-close]',nav).forEach(function(b){b.addEventListener('click',function(){setNav(false)})});
}
var searchBtn=$('[data-search-toggle]'),searchPanel=$('#search-panel');
if(searchBtn&&searchPanel){
  searchBtn.addEventListener('click',function(){
    var open=searchPanel.hidden;searchPanel.hidden=!open;searchBtn.setAttribute('aria-expanded',String(open));
    if(open){var i=$('input[type=search]',searchPanel);i&&i.focus()}
  });
}
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  if(nav&&!nav.hidden)setNav(false);
  if(searchPanel&&!searchPanel.hidden){searchPanel.hidden=true;searchBtn.setAttribute('aria-expanded','false');searchBtn.focus()}
});
document.addEventListener('submit',function(e){
  var f=e.target;
  if(f.matches&&f.matches('[data-search-form]')){var q=$('input[name=q]',f);track('search',{search_term:q?q.value:''})}
});

/* ---------- dodawanie do koszyka (AJAX) + Kup teraz + zestawy ---------- */
document.addEventListener('submit',function(e){
  var f=e.target;if(!f.matches||!f.matches('[data-ajax-cart]'))return;
  e.preventDefault();
  var sub=e.submitter,buyNow=!!(sub&&sub.hasAttribute&&sub.hasAttribute('data-buy-now'));
  var btn=sub||$('[type=submit]',f),errEl=$('[data-form-error]',f.parentNode);
  if(errEl)errEl.hidden=true;
  if(btn)btn.setAttribute('aria-busy','true');
  var root=f.closest('[data-product-root]'),api=root&&root.lumiBundle,list=api&&api.items();
  var req=list
    ?fetch(T.routes.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:list})})
    :fetch(T.routes.cartAdd+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});
  req.then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
    .then(function(res){
      if(!res.ok){var m=res.d.description||res.d.message||T.strings.error;toast(m,true);if(errEl){errEl.textContent=m;errEl.hidden=false}return}
      var its=(res.d.items||[res.d]).map(toItem),val=0;its.forEach(function(i){val+=i.price*i.quantity});
      track('add_to_cart',{ecommerce:{currency:T.currency,value:val,items:its}});
      if(buyNow){window.location.href=(sub.getAttribute('data-target')==='checkout'?T.routes.checkout:T.routes.cart);return}
      toast(T.strings.added,false,true);refreshCount();
    })
    .catch(function(){toast(T.strings.error,true)})
    .then(function(){if(btn)btn.removeAttribute('aria-busy')});
});

/* ---------- ilość (+/-) ---------- */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-qty-btn]');if(!b)return;
  var inp=$('input',b.closest('[data-qty]')),min=parseInt(inp.min||'0',10);
  var v=(parseInt(inp.value||'1',10)||1)+(b.dataset.qtyBtn==='plus'?1:-1);
  inp.value=Math.max(v,min);inp.dispatchEvent(new Event('change',{bubbles:true}));
});

/* ---------- koszyk: zmiana ilości, begin_checkout ---------- */
document.addEventListener('change',function(e){
  var i=e.target;if(!i.matches||!i.matches('[data-cart-qty]'))return;
  fetch(T.routes.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:parseInt(i.dataset.line,10),quantity:parseInt(i.value,10)||0})})
    .then(function(){window.location.reload()}).catch(function(){toast(T.strings.error,true)});
});
document.addEventListener('click',function(e){
  var b=e.target.closest('[name=checkout]');if(!b)return;
  var j=$('#cart-json');if(!j)return;
  try{var c=JSON.parse(j.textContent);track('begin_checkout',{ecommerce:{currency:c.currency,value:c.total_price/100,items:c.items.map(toItem)}})}catch(err){}
});

/* ---------- strona produktu ---------- */
function initProduct(root){
  var vj=$('[data-variants]',root),variants=vj?JSON.parse(vj.textContent):[];
  var track_=$('[data-gallery-track]',root),slides=$$('.gallery-slide',track_||root),thumbs=$$('[data-thumb]',root),st;
  function go(i){if(track_)track_.scrollTo({left:i*track_.clientWidth,behavior:'smooth'})}
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){go(i)})});
  function cur(){return track_?Math.round(track_.scrollLeft/(track_.clientWidth||1)):0}
  function sync(){
    var i=cur();
    thumbs.forEach(function(t,j){t.setAttribute('aria-current',j===i?'true':'false')});
    var th=thumbs[i];if(th&&th.parentNode){var bar=th.parentNode;bar.scrollTo({left:th.offsetLeft-(bar.clientWidth-th.offsetWidth)/2,behavior:'smooth'})}
    $$('[data-gallery-nav]',root).forEach(function(b){b.disabled=b.getAttribute('data-gallery-nav')==='prev'?i<=0:i>=slides.length-1});
  }
  if(track_){track_.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(sync,80)},{passive:true});sync()}
  $$('[data-gallery-nav]',root).forEach(function(b){b.addEventListener('click',function(){go(Math.max(0,Math.min(slides.length-1,cur()+(b.getAttribute('data-gallery-nav')==='next'?1:-1))))})});
  var idInput=$('[data-product-form] input[name=id]',root),atcs=$$('[data-atc]',root.parentNode.querySelectorAll?root.parentNode:root);
  var radios=$$('[data-option-index]',root);
  function selected(){var sel=[];radios.forEach(function(r){if(r.checked)sel[parseInt(r.dataset.optionIndex,10)]=r.value});return sel}
  function apply(v){
    var sel=selected();
    $$('[data-option-label]',root).forEach(function(l){l.textContent=sel[parseInt(l.dataset.optionLabel,10)]||''});
    var avail=!!(v&&v.available);
    if(idInput){if(v)idInput.value=v.id;idInput.disabled=!avail}
    var label=avail?T.strings.add:(v?T.strings.soldOut:T.strings.unavailable);
    $$('[data-atc],[data-buy-now]',document).forEach(function(b){if(!root.contains(b)&&!b.closest('[data-sticky-bar]'))return;b.disabled=!avail;var s=$('[data-atc-label]',b);if(s)s.textContent=label});
    $$('[data-price]',document).forEach(function(p){if(v&&(root.contains(p)||p.closest('[data-sticky-bar]')))p.textContent=v.price});
    $$('[data-compare]',root).forEach(function(c){if(v&&v.compare){c.textContent=v.compare;c.hidden=false}else{c.hidden=true}});
    if(v){
      var u=new URL(window.location.href);u.searchParams.set('variant',v.id);window.history.replaceState({},'',u);
      if(v.media){for(var i=0;i<slides.length;i++){if(slides[i].dataset.mediaId==String(v.media)){go(i);break}}}
    }
  }
  radios.forEach(function(r){r.addEventListener('change',function(){
    var sel=selected();
    var v=variants.filter(function(x){return x.options.every(function(o,i){return o===sel[i]})})[0];apply(v);
  })});
  /* zestawy (oferty 1 / 2 / 3 sztuki z wyborem rozmiaru) */
  var bwrap=$('[data-bundles]',root);
  if(bwrap){root.lumiBundle=(function(){
    var fmt=null;try{fmt=new Intl.NumberFormat(document.documentElement.lang||'pl',{style:'currency',currency:T.currency})}catch(err){}
    function money(c){return fmt?fmt.format(c/100):(c/100).toFixed(2)}
    var byId={};variants.forEach(function(v){byId[v.id]=v});
    var first=variants.filter(function(v){return v.available})[0]||variants[0];
    var lab={};variants.forEach(function(v){lab[v.label]=1});
    var multi=variants.length>1&&Object.keys(lab).length>1;
    var cards=$$('[data-bundle]',bwrap),current=null,sizeLabel=bwrap.getAttribute('data-size-label')||'',stickyBar=$('[data-sticky-bar]');
    function refresh(card){
      var L=card.lumi,sum=0,cmp=0;
      L.ids.forEach(function(id){var v=byId[id];sum+=v.cents;cmp+=(v.compare_cents>v.cents?v.compare_cents:v.cents)});
      L.total=Math.round(sum*(100-L.d)/100);
      var p=$('[data-bundle-price]',card),c=$('[data-bundle-compare]',card);
      p.textContent=money(L.total);
      if(cmp>L.total){c.textContent=money(cmp);c.hidden=false}else{c.hidden=true}
      if(card===current)updateSticky();
    }
    function updateSticky(){if(stickyBar&&current){$$('[data-price]',stickyBar).forEach(function(p){p.textContent=money(current.lumi.total)})}}
    function showMedia(card){var v=byId[card.lumi.ids[0]];if(v&&v.media){for(var i=0;i<slides.length;i++){if(slides[i].dataset.mediaId==String(v.media)){go(i);break}}}}
    function select(card,silent){
      current=card;
      cards.forEach(function(c){var on=c===card;c.classList.toggle('is-selected',on);$('input[type=radio]',c).checked=on});
      updateSticky();if(!silent)showMedia(card);
    }
    cards.forEach(function(card){
      var q=parseInt(card.dataset.qty,10)||1,L=card.lumi={q:q,d:parseFloat(card.dataset.discount)||0,ids:[],total:0};
      for(var i=0;i<q;i++)L.ids.push(first.id);
      var box=$('[data-bundle-sizes]',card);
      if(multi&&box){
        var t=document.createElement('span');t.className='bundle__sizes-title';t.textContent=sizeLabel;box.appendChild(t);
        L.ids.forEach(function(_,i){
          var row=document.createElement('label');row.className='bundle__size';
          if(q>1){var n=document.createElement('span');n.className='bundle__n';n.textContent='#'+(i+1);row.appendChild(n)}
          var sel=document.createElement('select');sel.setAttribute('aria-label',sizeLabel+' #'+(i+1));
          variants.forEach(function(v){var o=document.createElement('option');o.value=v.id;o.textContent=v.label+(v.available?'':' – '+T.strings.soldOut);o.disabled=!v.available;if(v.id===L.ids[i])o.selected=true;sel.appendChild(o)});
          sel.addEventListener('change',function(){L.ids[i]=parseInt(sel.value,10);refresh(card);if(i===0&&card===current)showMedia(card)});
          row.appendChild(sel);box.appendChild(row);
        });
      }
      $('input[type=radio]',card).addEventListener('change',function(){select(card)});
      refresh(card);
    });
    select(cards.filter(function(c){return c.classList.contains('is-selected')})[0]||cards[0],true);
    return{items:function(){
      if(!current)return null;var m={};
      current.lumi.ids.forEach(function(id){m[id]=(m[id]||0)+1});
      return Object.keys(m).map(function(id){return{id:parseInt(id,10),quantity:m[id]}});
    }};
  })()}
  /* sticky bar (mobile) */
  var bar=$('[data-sticky-bar]'),main=$('[data-product-form] [data-atc]',root);
  if(bar&&main&&'IntersectionObserver' in window){
    document.body.classList.add('has-sticky-bar');
    new IntersectionObserver(function(en){bar.classList.toggle('is-visible',!en[0].isIntersecting)},{threshold:0}).observe(main);
  }
}
$$('[data-product-root]').forEach(initProduct);

/* ---------- rekomendacje (Section Rendering API) ---------- */
if(!customElements.get('product-recs')){
  customElements.define('product-recs',function(){
    return class extends HTMLElement{
      connectedCallback(){
        var el=this;
        function load(){
          fetch(el.dataset.url).then(function(r){return r.text()}).then(function(t){
            var d=new DOMParser().parseFromString(t,'text/html'),c=$('[data-recs-content]',d);
            if(c&&c.children.length){el.insertAdjacentHTML('beforeend',c.innerHTML);el.hidden=false}else{el.remove()}
          }).catch(function(){el.remove()});
        }
        if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){if(en[0].isIntersecting){io.disconnect();load()}},{rootMargin:'300px'});io.observe(el)}else{load()}
      }
    };
  }());
}

/* ---------- sortowanie kolekcji ---------- */
document.addEventListener('change',function(e){
  var s=e.target;if(!s.matches||!s.matches('[data-sort]'))return;
  var u=new URL(window.location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');window.location.href=u.toString();
});

/* ---------- popup newsletter ---------- */
var pop=$('[data-popup]');
if(pop&&typeof pop.showModal==='function'){
  var KEY='lumidraw_popup',days=parseFloat(pop.dataset.days)||14,delay=(parseFloat(pop.dataset.delay)||12)*1000;
  var stamp=function(){try{localStorage.setItem(KEY,String(Date.now()))}catch(e){}};
  var seen=false;try{var ts=parseInt(localStorage.getItem(KEY)||'0',10);seen=ts&&(Date.now()-ts)<days*864e5}catch(e){}
  var open=function(){if(!pop.open)pop.showModal()};
  var dismiss=function(){stamp();pop.close()};
  $$('[data-popup-close]',pop).forEach(function(b){b.addEventListener('click',dismiss)});
  pop.addEventListener('click',function(e){if(e.target===pop)dismiss()});
  pop.addEventListener('cancel',stamp);
  if($('[data-newsletter-success]',pop)){open();stamp()}
  else if(!seen&&!(window.Shopify&&window.Shopify.designMode)){setTimeout(open,delay)}
  document.addEventListener('shopify:section:select',function(e){if(e.target.contains(pop))open()});
  document.addEventListener('shopify:section:deselect',function(e){if(e.target.contains(pop))pop.close()});
}
if($('[data-newsletter-success]')){track('newsletter_signup',{method:'form'})}
/* ---------- kafelki filmów (autoodtwarzanie po wejściu na stronę, bez dźwięku) ---------- */
function startTile(tile){
  if(!tile||tile.classList.contains('is-playing'))return;
  var tpl=$('template',tile),media=$('.vtile__media',tile);
  if(!tpl||!media)return;
  media.innerHTML='';media.appendChild(tpl.content.cloneNode(true));tile.classList.add('is-playing');
  var v=$('video',media);
  if(v){v.muted=true;v.defaultMuted=true;v.loop=true;v.setAttribute('playsinline','');v.setAttribute('muted','');var p=v.play();if(p&&p.catch)p.catch(function(){})}
}
$$('[data-vtile]').forEach(startTile);
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-vplay]');if(!b||b.disabled)return;
  startTile(b.closest('[data-vtile]'));
});
/* ---------- pasek opinii: pauza ---------- */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-marquee-toggle]');if(!b)return;
  var m=b.closest('section').querySelector('.pcards--marquee');if(!m)return;
  var p=m.classList.toggle('is-paused');b.setAttribute('aria-pressed',String(p));
});

/* ---------- licznik (godz : min : sek), po zakończeniu cyklu liczy od nowa ---------- */
$$('[data-countdown]').forEach(function(el){
  var cycle=(parseFloat(el.getAttribute('data-hours'))||24)*3600;
  function pad(n){return n<10?'0'+n:''+n}
  function tick(){
    var now=new Date(),mid=new Date(now.getFullYear(),now.getMonth(),now.getDate()).getTime();
    var left=cycle-(Math.floor((now.getTime()-mid)/1000)%cycle);
    el.textContent=pad(Math.floor(left/3600))+':'+pad(Math.floor(left%3600/60))+':'+pad(left%60);
  }
  tick();setInterval(tick,1000);
});
})();
